import React, { useEffect } from 'react';
import Content from 'studio/components/Content/Content';
import { trackEvent } from 'utils/eventTracking';
import Typography from '@mui/material/Typography';
import CodeIcon from '@mui/icons-material/CodeRounded';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { veezooUrls } from 'config/constants';
import PageTitle from 'studio/components/PageTitle';

// This page should only be shown in case the organization doesn't have access to embedded Veezoo.
const Embedded = () => {
  useEffect(() => {
    trackEvent('Admin Embedded Opened');
  }, []);

  return (
    <Content>
      <PageTitle icon={CodeIcon}>Embedded</PageTitle>

      <Typography variant="body1" gutterBottom>
        Check our{' '}
        <Link href={`${veezooUrls.docs}/embedded/embedded-guide`} target="_blank" rel="noreferrer">
          embedded guide
        </Link>{' '}
        and get in touch with us to embed Veezoo into your application!
      </Typography>
      <Button
        color="primary"
        variant="contained"
        href="https://www.veezoo.com/contact/"
        target="_blank"
        rel="noreferrer"
      >
        Contact us
      </Button>
    </Content>
  );
};

export default Embedded;
